export default __webpack_public_path__ + "static/logo-2e09264920ddd44b1a57e6eb363f673c.png";